<template>
    <v-content>
        <v-row>
            <v-img src="https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1951&q=80">            
                <v-theme-provider dark>
                    <v-container fill-height>
                        <v-row align="center" class="white--text mx-auto" justify="center">
                            <v-col class="white--text text-center" cols="12" tag="h1">
                                <span class="font-weight-light" :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']">
                                WELCOME TO
                                </span>
                                <br>
                                <span class="font-weight-black" :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']">
                                PENGUINTORY
                                </span>
                                <v-row>
                                    <v-col>
                                        <span class="font-weight-light" :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']">
                                            Order & Inventory Management system
                                        </span>
                                    </v-col>
                                </v-row>
                                <span :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']">
                                    <v-btn x-large rounded color="green" dark class="TitleButtonFont mt-6" href="https://penguintory-alpha.web.app/register">ทดลองใช้งาน ฟรี</v-btn>
                                    <!-- <v-btn x-large rounded color="green" dark class="TitleButtonFont mt-6" href="https://forms.gle/FnQLofFo7a1o1yYd8">สมัครรับข้อมูลพิเศษจากเรา</v-btn> -->
                                </span>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-theme-provider>
            </v-img>
        </v-row>

        <div class="py-12"></div>
        <v-container class="text-center">
            <h2 class="display-2 font-weight-bold mb-3">What is Penguintory</h2>
            <v-responsive class="mx-auto whatIsFont mb-8 mt-12" max-width="720">
                <p class="whatIsFont">Penguintory คือ ระบบจัดการออเดอร์ และ สต๊อกสินค้า สำเร็จรูป <br> ใช้งานง่าย สำหรับนักธุรกิจยุคใหม่</p>
                <!-- <p class="NoticeFont">** ตอนนี้โปรแกรมอยู่ในช่วงทดลองสินค้า สามารถใช้งานได้ฟรี **</p>
                <p class="NoticeFont">** ช้อมูลอาจมีการสูญหาย **</p> -->
            </v-responsive>
        </v-container>
        <div class="py-12"></div>

        <v-container class="text-center">
            <h2 class="display-2 font-weight-bold mb-3">Penguintory Features</h2>
            <v-row class="mt-12">
                <v-col v-for="({ icon, title, text }, i) in features" :key="i" cols="12" md="4">
                    <v-card class="py-12 px-4" color="grey lighten-3" flat>
                        <v-theme-provider dark>
                            <div>
                                <v-avatar color="primary" size="88">
                                <v-icon large v-text="icon"></v-icon>
                                </v-avatar>
                            </div>
                        </v-theme-provider>
                        
                        <v-card-title class="justify-center whatIsFont" v-text="title"></v-card-title>
                        <v-card-text class="featureFont" v-text="text"></v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-row>
            <v-col align='center' justify='center'>
                <v-btn x-large rounded color="green" dark class="TitleButtonFont mt-6" href="https://penguintory-alpha.web.app/register">ทดลองใช้งาน ฟรี</v-btn>
                <!-- <v-btn x-large rounded color="green" dark class="TitleButtonFont mt-6" href="https://forms.gle/FnQLofFo7a1o1yYd8">สมัครรับข้อมูลพิเศษจากเรา</v-btn> -->
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
export default {
    name: 'Body',
    data() {
        return{
            features: [
                {
                    icon: 'mdi-warehouse',
                    title: 'ระบบจัดการคลังสินค้า',
                    text: 'ระบบบันทึก และ จัดการสต๊อกสินค้า',
                },
                {
                    icon: 'mdi-cart',
                    title: 'ระบบขายสินค้าและสั่งซื้อสินค้า',
                    text: 'ระบบ จัดการออเดอร์สินค้า และ สั่งซื้อสินค้า',
                },
                {
                    icon: 'mdi-file-document',
                    title: 'ระบบเอกสาร',
                    text: 'ระบบจัดพิมพ์เอกสาร แบบฟอร์มต่าง ๆ',
                },
            ]
        }
    }
}
</script>

<style>
.TitleButtonFont{
  font-family: 'Prompt';
  font-weight: 600;
  color:white;
}

.whatIsFont{
  font-family: 'Prompt';
  font-weight: 400;
  font-size: 16pt;
  color:rgb(43, 43, 43);
}

.featureFont{
  font-family: 'Prompt';
  font-weight: 400;
  font-size: 12pt;
  color:rgb(73, 73, 73);
}

.NoticeFont{
  font-family: 'Prompt';
  font-weight: 400;
  font-size: 14pt;
  color: red;
}
</style>